'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trait = exports.TraitImage = exports.TraitIcon = exports.Traits = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 1em;\n  padding: 0;\n  margin: 0;\n  ', '\n  align-items: start;\n  grid-gap: 2em 3em;\n  grid-template-columns: 1fr;\n  @media ', ' {\n    ', '\n  }\n'], ['\n  font-size: 1em;\n  padding: 0;\n  margin: 0;\n  ', '\n  align-items: start;\n  grid-gap: 2em 3em;\n  grid-template-columns: 1fr;\n  @media ', ' {\n    ', '\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: ', 'px;\n  min-width: ', 'px;\n  margin-bottom: 1em;\n  border-radius: 50%;\n'], ['\n  max-width: ', 'px;\n  min-width: ', 'px;\n  margin-bottom: 1em;\n  border-radius: 50%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  max-width: 200px;\n  min-width: 200px;\n  margin-bottom: 1em;\n  border-radius: 50%;\n'], ['\n  max-width: 200px;\n  min-width: 200px;\n  margin-bottom: 1em;\n  border-radius: 50%;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  list-style-type: none;\n  ', '\n\n  & h4 {\n    font-size: 1.15em;\n    line-height: 1.25em;\n    margin: 0 0 0.3em 0;\n    font-weight: 400;\n  }\n\n  & p {\n    text-align: center;\n    line-height: 1.4em;\n    margin: 0;\n  }\n'], ['\n  list-style-type: none;\n  ', '\n\n  & h4 {\n    font-size: 1.15em;\n    line-height: 1.25em;\n    margin: 0 0 0.3em 0;\n    font-weight: 400;\n  }\n\n  & p {\n    text-align: center;\n    line-height: 1.4em;\n    margin: 0;\n  }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

var _animate = require('./animate');

var _LazyImg = require('./LazyImg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var TRAIT_HEIGHT = 70;

var gridCentered = '\n  display: grid;\n  align-items: center;\n  justify-items: center;\n';

/*::
type TraitsProps = {|
    children: any,
|}
*/
var Traits /*: ComponentType<TraitsProps> */ = exports.Traits = _styledComponents2.default.ul(_templateObject, gridCentered, _styles.styles.media.tablet, function (_ref) {
  var children = _ref.children;
  return '\n    grid-template-columns: repeat(' + React.Children.count(children) + ', 1fr);\n    ';
});
Traits.displayName = 'Traits';

var TraitIcon = exports.TraitIcon = (0, _styledComponents2.default)(_LazyImg.LazyImg)(_templateObject2, TRAIT_HEIGHT, TRAIT_HEIGHT);
TraitIcon.displayName = 'TraitIcon';

var TraitImage = exports.TraitImage = TraitIcon.extend(_templateObject3);
TraitImage.displayName = 'TraitImage';

/*::
type TraitProps = {|
    className?: string,
    title: string,
    image?: string,
    icon?: string,
    children: any,
    animation?: Object,
|}
*/
var Trait /*: ComponentType<TraitProps> */ = exports.Trait = (0, _styledComponents2.default)((0, _animate.animate)('traitRef')(function (_ref2) {
  var className = _ref2.className,
      title = _ref2.title,
      image = _ref2.image,
      icon = _ref2.icon,
      traitRef = _ref2.traitRef,
      children = _ref2.children;
  return React.createElement(
    'li',
    { className: className, ref: traitRef },
    icon && React.createElement(TraitIcon, { src: icon, alt: title, height: TRAIT_HEIGHT }),
    image && React.createElement(TraitImage, { src: image, alt: title }),
    React.createElement(
      'h4',
      null,
      title
    ),
    React.createElement(
      'p',
      null,
      children
    )
  );
}))(_templateObject4, gridCentered);

Trait.displayName = 'Trait';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Traits.js
// module id = 648
// module chunks = 0